import { useTranslation } from 'react-i18next';
import { FR_APPLICATION_STATUSES, FR_STEPS } from '@/helpers/fundraising';
import { InfoMessage } from '@/components/InfoMessage';
import { APP_LINKS } from '@/helpers/links';
import s from './index.module.scss';

export const BorrowerMessages = ({ status, fundraisingId, application}) => {
  const { t } = useTranslation();

  if (!application || !status) return null;

  if (
    (application.status === null &&
      !Object.keys(application.reporting.required_documents).length) ||
    application.status === FR_APPLICATION_STATUSES.IN_REVIEW ||
    application.status === FR_APPLICATION_STATUSES.PRE_CHECKS ||
    application.status === FR_APPLICATION_STATUSES.RESUBMITTED
  ) {
   return (
     <div className={s.notifications}>
       <InfoMessage
         type="info"
         title={t('fundraising:app_messages.application_under_review')}
         description={t('fundraising:app_messages.received_financial_documents')}
       />
     </div>
   );
  }

  if (application.status === FR_APPLICATION_STATUSES.CHANGES_REQUESTED) {
    return (
      <div className={s.notifications}>
        <InfoMessage
          type="action"
          title={t('fundraising:app_messages.action_required')}
          description={application.comment}
          linkLabel={t('fundraising:app_messages.update_documents')}
          linkUrl={APP_LINKS.fundraisingApplication}
          linkState={{
            fundraisingId,
            newFunds: application.new_funds,
            refinancing: application.refinancings?.filter(fundraising => fundraising.checked) ?? [],
          }}
        />
      </div>
    );
  }

  if (application.status === FR_APPLICATION_STATUSES.REJECTED) {
    return (
      <div className={s.notifications}>
        <InfoMessage
          type="error"
          title={t('fundraising:app_messages.application_rejected')}
          description={application.comment}
        />
      </div>
    );
  }

  if (status.step === FR_STEPS.awaiting_lender) {
    return (
      <div className={s.notifications}>
        <InfoMessage
          type="success"
          title={t('fundraising:app_messages.application_approved_sent_lender', {
            round: application.fundraising_name,
          })}
          description={t('fundraising:app_messages.application_approved_sent_lender_desc')}
        />
      </div>
    );
  }

  if (status.step === FR_STEPS.awaiting_borrower_guarantor) {
    return (
      <div className={s.notifications}>
      <InfoMessage
        type="info"
        title={t('fundraising:app_messages.review_and_confirm')}
        description={t('fundraising:app_messages.review_and_confirm_desc')}
      />
      </div>
    )
  }

  return null;
};